module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0007.jpg?v=93981cba";